module.exports = __webpack_public_path__ + "img/1@3x.32d33e4a.png";